import { Container, FederatedPointerEvent } from "pixi.js";
import { MyWalletTypeView } from "./MyWalletTypeView";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { MyWalletAddressDataView } from "./MyWalletAddressDataView";
import { MyWalletNetworkDataView } from "./MyWalletNetworkDataView";
import { MyWalletDisconnectButton } from "./MyWalletDisconnectButton";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";
import { Event } from "event-system";
import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { MyWalletsBoxElementType } from "../wallets/MyWalletsBoxElementType";

export class MyWalletInfoView extends Container {
    private readonly commonResources: CommonResourcesPackage;
    private readonly myWalletResources: MyWalletResourcePackage;

    private typeView: MyWalletTypeView;
    private walletAddressData: MyWalletAddressDataView;
    private walletNetworkDataView?: MyWalletNetworkDataView;
    private disconectButton?: MyWalletDisconnectButton;

    public set networkName(value: string) {
        this.walletNetworkDataView.networkType = value;
    }

    public set supportedNetwork(value: boolean) {
        this.walletNetworkDataView.supportedNetwork = value;
    }

    public get onDisconnectButtonClick(): Event<ButtonWithScaleAnimation, FederatedPointerEvent> {
        return this.disconectButton?.onUp;
    }

    public get onCopyAddressButtonClick(): Event<string> {
        return this.walletAddressData.onCopyAddress;
    }

    public get onSwitchNetworkClick(): Event<void> {
        return this.walletNetworkDataView?.onSwitchNetwork;
    }

    public constructor(
        commonResources: CommonResourcesPackage,
        myWalletResources: MyWalletResourcePackage,
        type: MyWalletsBoxElementType,
        walletAddress: string,
        networkName?: string,
        supportedNetwork?: boolean
    ) {
        super();
        this.commonResources = commonResources;
        this.myWalletResources = myWalletResources;
        this.build(type, walletAddress, networkName, supportedNetwork);
        this.layout();
    }

    private build(type: MyWalletsBoxElementType, walletAddress: string, networkName: string, supportedNetwork: boolean): void {
        this.typeView = new MyWalletTypeView(this.commonResources, type);
        this.walletAddressData = new MyWalletAddressDataView(this.myWalletResources, walletAddress);
        this.addChild(this.typeView, this.walletAddressData);
        if (type == MyWalletsBoxElementType.THIRDWEB) {
            this.walletNetworkDataView = new MyWalletNetworkDataView(this.myWalletResources, this.commonResources, networkName, supportedNetwork);
            this.addChild(this.walletNetworkDataView);
        } else {
            this.disconectButton = new MyWalletDisconnectButton(this.myWalletResources);
            this.addChild(this.disconectButton);
        }
    }

    private layout(): void {
        const width = 593;
        this.typeView.position.set(width * 0.5 - this.typeView.width * 0.5, 54);
        this.walletAddressData.position.set(57, 169);
        this.walletNetworkDataView?.position.set(50, 264);
        this.disconectButton?.position.set(224, 356);
    }
}